import { useState } from 'react';
import { useEffectOnce } from 'react-use';

export function useDeprioritizeComponents() {
    const [showDeprioritizedComponents, setShowDeprioritizedComponents] = useState(false);

    useEffectOnce(() => {
        const rafId = requestAnimationFrame(() => {
            setShowDeprioritizedComponents(true);
        });

        return () => {
            cancelAnimationFrame(rafId);
        };
    });

    return showDeprioritizedComponents;
}
